import type {
  IOpportunityDocument,
  IOpportunityUploadDocument,
} from './../types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createOpportunityDocument,
  updateDocument: updateOpportunityDocument,
  deleteDocument: deleteOpportunityDocument,
} = makeDocumentService<IOpportunityDocument, IOpportunityUploadDocument>(
  '/api/opportunitydocuments',
  'opportunityDocument'
)
